(function () {
  if (window.avenciCartLoaded) return; window.avenciCartLoaded = true;
  var cfg = window.avenci || {};
  var GOAL = cfg.freeShipGoal || 5000;           // cents
  var TIMER_SECONDS = 300;
  var root = document.getElementById('AvCart');
  if (!root) return;
  var body = root.querySelector('[data-av-cart-body]');
  var foot = root.querySelector('[data-av-cart-foot]');
  var cart = null;
  var timerInt = null;

  function money(cents) {
    var fmt = (cfg.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    var v = (cents / 100);
    var amount = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]; }); }
  function truckSvg() { return '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9 1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>'; }

  function fetchCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(url, data) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function upsellLine() {
    if (!cfg.upsell || !cart) return null;
    for (var i = 0; i < cart.items.length; i++) if (cart.items[i].variant_id === cfg.upsell.variantId) return cart.items[i];
    return null;
  }

  function startTimer() {
    var el = root.querySelector('[data-timer]');
    if (!el) return;
    var start;
    try { start = parseInt(sessionStorage.getItem('avCartTimer') || '0', 10); } catch (e) { start = 0; }
    var now = Date.now();
    if (!start || now - start > TIMER_SECONDS * 1000) { start = now; try { sessionStorage.setItem('avCartTimer', String(start)); } catch (e) {} }
    clearInterval(timerInt);
    function tick() {
      var left = Math.max(0, TIMER_SECONDS - Math.floor((Date.now() - start) / 1000));
      var m = Math.floor(left / 60), s = left % 60;
      el.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      if (left === 0) { clearInterval(timerInt); try { sessionStorage.removeItem('avCartTimer'); } catch (e) {} }
    }
    tick(); timerInt = setInterval(tick, 1000);
  }

  function render() {
    var up = upsellLine();
    var items = cart.items.filter(function (i) { return !up || i.key !== up.key; });
    document.querySelectorAll('[data-av-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.setAttribute('data-count', cart.item_count); });

    if (!items.length) {
      body.innerHTML = '<div class="av-empty"><h3>Your cart is empty</h3><a class="av-checkout" href="/collections/all">Continue shopping</a>' +
        (window.avenci.customerLoggedIn ? '' : '<p>Have an account? <a href="/account/login">Log in</a> to check out faster.</p>') + '</div>';
      foot.innerHTML = '';
      if (up) changeLine(up.key, 0);
      return;
    }

    var goods = items.reduce(function (a, i) { return a + i.final_line_price; }, 0);
    var remaining = Math.max(0, GOAL - goods);
    var pct = Math.min(100, Math.round(goods / GOAL * 100));
    var savings = 0;

    var html = '';
    html += '<div class="av-cart__timer"><strong>Your cart is reserved for </strong><span data-timer>5:00</span></div>';
    html += '<div class="av-ship"><p class="av-ship__msg">' + (remaining > 0 ? 'Spend <strong>' + money(remaining) + '</strong> more to get FREE shipping!' : 'Congrats! You get FREE shipping!') +
      '</p><div class="av-ship__bar"><div class="av-ship__fill" style="width:' + pct + '%"></div><span class="av-ship__icon">' + truckSvg() + '</span></div></div>';
    html += '<div class="av-items">';
    items.forEach(function (i) {
      var lineCompare = (i.av_compare || 0) * i.quantity;
      var lineSave = Math.max(0, lineCompare - i.final_line_price);
      savings += lineSave + (i.total_discount || 0);
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : '';
      html += '<div class="av-item" data-key="' + esc(i.key) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="' + esc(i.product_title) + '" loading="lazy">' : '<span></span>') +
        '<div><div class="av-item__title">' + esc(i.product_title) + '</div>' +
        (i.variant_title ? '<div class="av-item__var">' + esc(i.variant_title) + '</div>' : '') +
        (lineSave > 0 ? '<div class="av-item__save"><strong>(You save ' + money(lineSave) + ')</strong></div>' : '') +
        '<div class="av-qty"><button type="button" data-qty="' + (i.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button><span>' + i.quantity + '</span><button type="button" data-qty="' + (i.quantity + 1) + '" aria-label="Increase quantity">+</button></div></div>' +
        '<div class="av-item__right"><div class="av-item__price">' + (lineCompare > i.final_line_price ? '<span class="av-item__was">' + money(lineCompare) + '</span>' : '') + money(i.final_line_price) + '</div>' +
        '<button type="button" class="av-remove" data-qty="0">Remove</button></div></div>';
    });
    html += '</div>';
    if (cfg.upsell) {
      html += '<div class="av-upsell">' + (cfg.upsell.image ? '<img src="' + esc(cfg.upsell.image) + '" alt="">' : '') +
        '<div class="av-upsell__txt">' + esc(cfg.upsell.title) + '</div><div class="av-upsell__price">' + money(cfg.upsell.price) + '</div>' +
        '<button type="button" class="av-switch" role="switch" aria-label="Add ' + esc(cfg.upsell.title) + '" aria-checked="' + (up ? 'true' : 'false') + '" data-av-upsell></button></div>';
    }
    body.innerHTML = html;

    var f = '';
    if (savings > 0) f += '<div class="av-sum av-sum--save"><strong>Savings</strong><strong>-' + money(savings) + '</strong></div>';
    f += '<div class="av-sum av-sum--sub"><strong>Subtotal</strong><strong>' + money(cart.total_price) + '</strong></div>';
    f += '<a class="av-checkout" href="/checkout">Checkout &rarr;</a>';
    foot.innerHTML = f;
    startTimer();
  }

  // cart.js has no compare-at price; look it up per product once
  var compareCache = {};
  function enrich() {
    var handles = [];
    cart.items.forEach(function (i) { if (!(i.handle in compareCache)) handles.push(i.handle); });
    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        compareCache[h] = {};
        if (p) p.variants.forEach(function (v) { compareCache[h][v.id] = v.compare_at_price || 0; });
      }).catch(function () { compareCache[h] = {}; });
    })).then(function () {
      cart.items.forEach(function (i) { i.av_compare = (compareCache[i.handle] || {})[i.variant_id] || 0; });
    });
  }

  function refresh() {
    return fetchCart().then(function (c) { cart = c; return enrich(); }).then(render);
  }
  function busy(on) { root.classList.toggle('is-busy', !!on); }
  function changeLine(key, qty) {
    busy(true);
    return post('/cart/change.js', { id: key, quantity: qty }).then(function (c) { cart = c; return enrich(); }).then(render).catch(function () { return refresh(); }).then(function () { busy(false); });
  }

  function open() {
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    return refresh();
  }
  function close() {
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-av-cart-close]')) { close(); return; }
    var q = e.target.closest('[data-qty]');
    if (q) { var item = q.closest('[data-key]'); changeLine(item.getAttribute('data-key'), parseInt(q.getAttribute('data-qty'), 10)); return; }
    var sw = e.target.closest('[data-av-upsell]');
    if (sw && cfg.upsell) {
      var line = upsellLine();
      busy(true);
      var p = line ? post('/cart/change.js', { id: line.key, quantity: 0 }) : post('/cart/add.js', { items: [{ id: cfg.upsell.variantId, quantity: 1 }] });
      p.then(refresh).catch(refresh).then(function () { busy(false); });
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) close(); });

  // Open the drawer from any cart link / icon
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="/cart"], a[href$="/cart"], [data-av-open-cart]');
    if (!a || root.contains(a)) return;
    e.preventDefault(); open();
  }, true);

  window.avenciCart = { open: open, close: close, refresh: refresh,
    add: function (items) { return post('/cart/add.js', { items: items }).then(function () { return open(); }); } };

  // Keep header count right after apps (e.g. bundles) add to cart
  document.addEventListener('cart:refresh', refresh);
  fetchCart().then(function (c) { cart = c; document.querySelectorAll('[data-av-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.setAttribute('data-count', c.item_count); }); });
})();
